import React, { useState, useEffect } from "react";
import axios from "axios";
import { Form, Button, Container, Row, Col, Card, Toast, ToastContainer } from "react-bootstrap";
import { BASE_URL } from "../../constants";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../../Context/AuthContext";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css'; 
const AddShelterScreen = () => {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [toastType, setToastType] = useState("success");
 const [newShelter, setNewShelter] = useState({
  name: "",
  address: {
    street: "",
    city: "",
    postalCode: "",
    country: ""
  },
  contactInfo: { phone: "", email: "" },
  responsiblePerson: "",
  costPerOccupant: "",
  stateCoverage: ""
});

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  useEffect(() => {
    if (user) {
      setNewShelter(prev => ({
        ...prev,
        responsiblePerson: user.id
      }));
    }
  }, [user]);

 const handleChange = (e) => {
  const { name, value } = e.target;

  if (["street", "city", "postalCode", "country"].includes(name)) {
    setNewShelter((prev) => ({
      ...prev,
      address: {
        ...prev.address,
        [name]: value
      }
    }));
  } else if (["phone", "email"].includes(name)) {
    setNewShelter((prev) => ({
      ...prev,
      contactInfo: {
        ...prev.contactInfo,
        [name]: value
      }
    }));
  } else {
    setNewShelter((prev) => ({
      ...prev,
      [name]: value
    }));
  }
};

const handleAddShelter = async () => {
  const { name, address, contactInfo, costPerOccupant, stateCoverage } = newShelter;

  // Validation
  if (
    !name ||
    !address.street || !address.city || !address.postalCode || !address.country ||
    !contactInfo.phone || !contactInfo.email ||
    !costPerOccupant || !stateCoverage
  ) {
    setToastType("danger");
    setToastMessage("All fields are required. Please complete the form.");
    setShowToast(true);
    return;
  }

  setLoading(true);
  try {
    await axios.post(`${BASE_URL}/shelters`, newShelter);

    const response = await axios.get(`${BASE_URL}/users/user/${user.id}`);
    const updatedUser = response.data;

    setUser(updatedUser);
    localStorage.setItem('userData', JSON.stringify(updatedUser));

    setNewShelter({
      name: "",
      address: { street: "", city: "", postalCode: "", country: "" },
      contactInfo: { phone: "", email: "" },
      responsiblePerson: user.id,
      costPerOccupant: "",
      stateCoverage: ""
    });

    setToastType("success");
    setToastMessage("Shelter added successfully!");
    setShowToast(true);
    setTimeout(() => navigate('/admin/dashboard'), 3000);

  } catch (error) {
    console.error("Error adding shelter:", error);
    setToastType("danger");
    setToastMessage(error.response?.data?.message || "Failed to add shelter. Please try again.");
    setShowToast(true);
  } finally {
    setLoading(false);
  }
};


  return (
    <Container className="py-5 d-flex justify-content-center">
    <Card className="p-4 shadow-sm rounded-4" style={{ width: '100%', maxWidth: '720px' }}>
      <h4 className="mb-4 fw-semibold">Add New Shelter</h4>
  
      <Form>
        <Row className="g-3">
          <Col >
            <Form.Group controlId="formName">
              <Form.Label className="small fw-semibold">Shelter Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={newShelter.name}
                onChange={handleChange}
                placeholder="Shelter Name"
              />
            </Form.Group>
          </Col>
  <Row>
     <Form.Label className="small fw-semibold">Address</Form.Label>
    <Col md={3}>
  <Form.Group controlId="formStreet">
    <Form.Label className="small fw-semibold">Street</Form.Label>
    <Form.Control
      type="text"
      name="street"
      value={newShelter.address.street}
      onChange={handleChange}
      placeholder="Street"
      required
    />
  </Form.Group>
</Col>

<Col md={3}>
  <Form.Group controlId="formCity">
    <Form.Label className="small fw-semibold">City</Form.Label>
    <Form.Control
      type="text"
      name="city"
      value={newShelter.address.city}
      onChange={handleChange}
      placeholder="City"
      required
    />
  </Form.Group>
</Col>

<Col md={3}>
  <Form.Group controlId="formPostalCode">
    <Form.Label className="small fw-semibold">Postal Code</Form.Label>
    <Form.Control
      type="text"
      name="postalCode"
      value={newShelter.address.postalCode}
      onChange={handleChange}
      placeholder="Postal Code"
      required
    />
  </Form.Group>
</Col>

<Col md={3}>
  <Form.Group controlId="formCountry">
    <Form.Label className="small fw-semibold">Country</Form.Label>
    <Form.Control
      type="text"
      name="country"
      value={newShelter.address.country}
      onChange={handleChange}
      placeholder="Country"
      required
    />
  </Form.Group>
</Col>
 </Row>
          
  
          <Col md={6}>
          <Form.Group controlId="formPhone">
  <Form.Label className="small fw-semibold">Phone</Form.Label>
  <PhoneInput
    country={'de'} 
    value={newShelter.contactInfo.phone}
    onChange={(phone) =>
      setNewShelter((prev) => ({
        ...prev,
        contactInfo: { ...prev.contactInfo, phone },
      }))
    }
    inputClass="form-control"
    inputStyle={{ width: '100%' }}
  />
</Form.Group>


          </Col>
  
          <Col md={6}>
            <Form.Group controlId="formEmail">
              <Form.Label className="small fw-semibold">Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={newShelter.contactInfo.email}
                onChange={handleChange}
                placeholder="Email Address"
              />
            </Form.Group>
          </Col>
  
          <Col md={6}>
            <Form.Group controlId="formCost">
              <Form.Label className="small fw-semibold">Cost per Occupant</Form.Label>
              <Form.Control
                type="number"
                name="costPerOccupant"
                value={newShelter.costPerOccupant}
                onChange={handleChange}
                placeholder="e.g. 100"
              />
            </Form.Group>
          </Col>
  
          <Col md={6}>
            <Form.Group controlId="formCoverage">
              <Form.Label className="small fw-semibold">State Coverage (%)</Form.Label>
              <Form.Control
                type="number"
                name="stateCoverage"
                value={newShelter.stateCoverage}
                onChange={handleChange}
                placeholder="e.g. 50"
              />
            </Form.Group>
          </Col>
        </Row>
  
        <div className="d-flex justify-content-end mt-4">
  <Button
    variant="info"
    className="rounded-pill px-4 py-2 fw-semibold"
    onClick={handleAddShelter}
    style={{ border: "none" }}
    disabled={loading} 
  >
    {loading ? (
      <>
        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
   
      </>
    ) : (
      "Save Changes"
    )}
  </Button>
</div>

      </Form>  
    </Card>
    <ToastContainer position="top-end" className="p-3">
  <Toast
    onClose={() => setShowToast(false)}
    show={showToast}
    delay={3000}
    autohide
    bg={toastType}
  >
    <Toast.Body className="text-white">{toastMessage}</Toast.Body>
  </Toast>
</ToastContainer>


  </Container>
  );
};

export default AddShelterScreen;